"use client";

import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Image from "@/components/Atoms/Image";
import { CloseModalIcon, ZoomInIcon } from "@/components/Atoms/Vectors";
import styles from "./HeroFeaturedZoomImage.module.scss";

interface HeroFeaturedZoomImageProps {
  image: any;
  iconColor?: { hex?: string };
  imageClassName?: string;
  buttonClassName?: string;
}

export default function HeroFeaturedZoomImage({
  image,
  iconColor,
  imageClassName = "",
  buttonClassName = "",
}: HeroFeaturedZoomImageProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={styles.imageWrap}>
        <Image data={image} className={imageClassName} objectFit="contain" />
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className={`${styles.zoomButton} ${buttonClassName}`}
          aria-label="Zoom image"
        >
          <ZoomInIcon color={iconColor} />
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[9999999]"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-80" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto flex justify-center">
            <div
              className={`${styles.popContainer} flex min-h-full items-center justify-center text-center fixed w-full max-w-[50rem] z-[999999]`}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative w-[90%] max-w-[50rem] transform overflow-hidden rounded-2xl m-auto flex justify-center flex-col items-center shadow-xl transition-all bg-white p-4">
                  <Image className="max-h-[90vh] z-[1]" data={image} />
                  <button
                    type="button"
                    className="absolute top-4 right-4 bg-white z-10 max-w-[2rem] hover:scale-125 transform-all duration-300 max-h-[2rem]"
                    onClick={() => setIsOpen(false)}
                    aria-label="Close zoom"
                  >
                    <CloseModalIcon
                      className="w-full h-full"
                      color={iconColor}
                    />
                  </button>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
